export default {"src":"https://cdn2.e-farm.com/website-static/_next/static/media/pl.c26de863.svg","height":10,"width":16,"blurWidth":0,"blurHeight":0};